import {FC, useEffect, useState} from "react";

export const FontsLoader: FC = ({children}) => {
  const [isFontsReady, setIsFontsReady] = useState(false);

  useEffect(() => {
    Promise.all([
      document.fonts.load("400 50px Roboto"),
      document.fonts.load("500 18px Roboto"),
      document.fonts.load("400 46px Roboto Mono"),
      document.fonts.load("500 40px Roboto Mono"),
    ]).then(() => setIsFontsReady(true))
  }, [])

  return (<>{isFontsReady && children}</>)
}
